.player {
  --pv-accent: #e11d2e;
  --pv-accent-soft: rgba(225, 29, 46, 0.35);
  --pv-glass: rgba(12, 14, 18, 0.72);
  --pv-glass-border: rgba(255, 255, 255, 0.08);
  --pv-text: #f4f5f7;
  --pv-muted: #a8adb8;
  --pv-font: 'Segoe UI', 'Helvetica Neue', system-ui, sans-serif;

  position: relative;
  width: 100%;
  aspect-ratio: 16 / 9;
  max-height: min(70vh, 640px);
  background: #050607;
  overflow: hidden;
  user-select: none;
  outline: none;
  border-radius: 14px;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.06),
    0 20px 50px rgba(0, 0, 0, 0.55);
  z-index: 1;
  font-family: var(--pv-font);
  color: var(--pv-text);
}

.player:fullscreen,
.player:-webkit-full-screen {
  border-radius: 0 !important;
  aspect-ratio: auto !important;
  max-height: none !important;
  max-width: none !important;
  width: 100vw !important;
  height: 100vh !important;
  inset: 0 !important;
  box-shadow: none !important;
}

.theater {
  max-height: min(85vh, 900px);
  border-radius: 0;
}

.mini {
  position: fixed !important;
  right: 16px;
  bottom: 16px;
  width: min(320px, 42vw) !important;
  max-height: none !important;
  aspect-ratio: 16 / 9;
  z-index: 9999;
  border-radius: 12px;
  box-shadow:
    0 0 0 1px rgba(255, 255, 255, 0.08),
    0 16px 40px rgba(0, 0, 0, 0.6);
}

.player:fullscreen.mini,
.player:-webkit-full-screen.mini {
  position: relative !important;
  right: auto !important;
  bottom: auto !important;
  width: 100vw !important;
  height: 100vh !important;
}

.showCursor {
  cursor: default;
}

.hideCursor {
  cursor: none;
}

.video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: contain;
  object-position: center;
  background: #050607;
  z-index: 1;
}

.player:fullscreen .video,
.player:-webkit-full-screen .video {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center center;
}

.video::cue {
  font-size: var(--pv-cue-size, 1.1em);
  color: var(--pv-cue-color, #fff);
  background: var(--pv-cue-bg, rgba(0, 0, 0, 0.75));
}

.spinner {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  pointer-events: none;
  z-index: 3;
}

.spinnerRing {
  width: 52px;
  height: 52px;
  border: 3px solid rgba(255, 255, 255, 0.18);
  border-top-color: var(--pv-accent);
  border-radius: 50%;
  animation: spin 0.7s linear infinite;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.seekFlash {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 4;
  background: rgba(12, 14, 18, 0.55);
  backdrop-filter: blur(8px);
  color: #fff;
  padding: 18px 22px;
  border-radius: 50%;
  font-weight: 700;
  letter-spacing: 0.02em;
  pointer-events: none;
  border: 1px solid rgba(255, 255, 255, 0.1);
  animation: seekPop 0.45s ease;
}

@keyframes seekPop {
  from {
    opacity: 0;
    transform: translateY(-50%) scale(0.85);
  }
  to {
    opacity: 1;
    transform: translateY(-50%) scale(1);
  }
}

.left {
  left: 12%;
}

.right {
  right: 12%;
}

@media (max-width: 640px) {
  .player {
    border-radius: 0;
    max-height: none;
  }

}
